import React from "react";
import { Routes, Route } from "react-router-dom";

import PrivateRoutes from "./PrivateRoutes";
import PublicRoutes from "./PublicRoutes";

function MainRoutes() {
  return (
    <Routes>
      <Route path="v/*" element={<PublicRoutes></PublicRoutes>}></Route>
      <Route path="*" element={<PrivateRoutes></PrivateRoutes>} />
    </Routes>
  );
}

export default MainRoutes;
